function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../logger';
import { JsonUtils } from '../../utils/json-utils';
import { InternalSessionState } from './internal-session-state';
import { SessionState } from './session-controller.enums';
export { PinRequiredCause, SessionState } from './session-controller.enums';
// Often disabled by clients for Clips
/**
 * @public
 */ /**
     * @deprecated This field is currently unused in the CVSDK JS Codebase
     */ // Overrides addon configurations
// Optionally disables adInsertion on session start
// NowTV specific be used as a Yospace query parameter
// Enables debug mode, so ads team can see ad requests
// https://github.com/sky-uk/atlas-web-and-tv/pull/20061/files#r447097383
// Needed by Chromecast as some adInsertion properties only come in on load request
/**
     * @deprecated This prop should not be used
     * Now determined internally by the SDK
     */ /**
 * @public
 */ /**
 * @public
 */ // TODO: Uncomment below once the reference app is ready
/**
 * @public
 */ export function isRawSessionItem(sessionItem) {
    return 'manifests' in sessionItem;
}
var _obj;
/**
 * @public
 */ // Ads
var MappedSessionStateForClients = (_obj = {}, _define_property(_obj, InternalSessionState.Initialized, SessionState.Initialized), _define_property(_obj, InternalSessionState.Loading, SessionState.Loading), _define_property(_obj, InternalSessionState.PlayerLoading, SessionState.Loading), _define_property(_obj, InternalSessionState.Playing, SessionState.Playing), _define_property(_obj, InternalSessionState.Paused, SessionState.Paused), _define_property(_obj, InternalSessionState.Rebuffering, SessionState.Rebuffering), _define_property(_obj, InternalSessionState.Seeking, SessionState.Seeking), _define_property(_obj, InternalSessionState.Stopping, SessionState.Stopping), _define_property(_obj, InternalSessionState.Stopped, SessionState.Stopped), _define_property(_obj, InternalSessionState.Finished, SessionState.Finished), _define_property(_obj, InternalSessionState.WaitingForPin, SessionState.WaitingForPin), _define_property(_obj, InternalSessionState.CsaiTransition, SessionState.Playing), _obj);
var _obj1;
var ReverseMappedSessionStateForClients = (_obj1 = {}, _define_property(_obj1, SessionState.Playing, InternalSessionState.Playing), _define_property(_obj1, SessionState.Paused, InternalSessionState.Paused), _define_property(_obj1, SessionState.Rebuffering, InternalSessionState.Rebuffering), _define_property(_obj1, SessionState.Seeking, InternalSessionState.Seeking), _define_property(_obj1, SessionState.Stopping, InternalSessionState.Stopping), _define_property(_obj1, SessionState.Stopped, InternalSessionState.Stopped), _define_property(_obj1, SessionState.Finished, InternalSessionState.Finished), _define_property(_obj1, SessionState.WaitingForPin, InternalSessionState.WaitingForPin), _obj1);
/**
 * @public
 */ export var SessionController = /*#__PURE__*/ function() {
    "use strict";
    function SessionController(sessionProxy, config) {
        var _this = this;
        _class_call_check(this, SessionController);
        var _config_csai;
        _define_property(this, "getCurrentSessionState", void 0);
        _define_property(this, "onStateChanged", void 0);
        _define_property(this, "onSessionRetryStarted", void 0);
        _define_property(this, "onSessionRetryEnded", void 0);
        _define_property(this, "onSessionRestartStarted", void 0);
        _define_property(this, "onSessionRestartEnded", void 0);
        _define_property(this, "onError", void 0);
        _define_property(this, "onWarning", void 0);
        _define_property(this, "onPlaybackTimelineUpdated", void 0);
        _define_property(this, "onBitrateChanged", void 0);
        _define_property(this, "onEncodedFrameRateChanged", void 0);
        _define_property(this, "onRenderedFrameRateChanged", void 0);
        _define_property(this, "onVideoTrackChanged", void 0);
        _define_property(this, "onItuQaSessionData", void 0);
        _define_property(this, "onAvailableAudioTracksChanged", void 0);
        _define_property(this, "onAvailableSubtitlesTracksChanged", void 0);
        _define_property(this, "onAvailableThumbnailVariantsChanged", void 0);
        _define_property(this, "onAudioTrackChanged", void 0);
        _define_property(this, "onSeekStarted", void 0);
        _define_property(this, "onSeekEnded", void 0);
        _define_property(this, "onSubtitlesTrackChanged", void 0);
        _define_property(this, "onSubtitleCuesChanged", void 0);
        _define_property(this, "onVolumeChanged", void 0);
        _define_property(this, "onMuteChanged", void 0);
        _define_property(this, "onSessionEnded", void 0);
        _define_property(this, "onPlayoutDataReceived", void 0);
        _define_property(this, "onPlayoutRulesReceived", void 0);
        _define_property(this, "onEventBoundary", void 0);
        _define_property(this, "onEndOfEventMarkerReceived", void 0);
        _define_property(this, "onAdStarted", void 0);
        _define_property(this, "onAdFinished", void 0);
        _define_property(this, "onAdBreakStarted", void 0);
        _define_property(this, "onAdBreakFinished", void 0);
        _define_property(this, "onAdBreakDataReceived", void 0);
        _define_property(this, "onAdPositionChanged", void 0);
        _define_property(this, "onPauseAd", void 0);
        _define_property(this, "onVerifyCompanionAdInsertionEnabled", void 0);
        _define_property(this, "onCompanionAdOpportunityStarted", void 0);
        _define_property(this, "onCompanionAdOpportunityEnded", void 0);
        _define_property(this, "onRenderWatermark", void 0);
        _define_property(this, "onClearWatermark", void 0);
        _define_property(this, "onClearWatermarks", void 0);
        _define_property(this, "onPinRequired", void 0);
        _define_property(this, "onPinSuccess", void 0);
        _define_property(this, "onAutoPlayPolicyPreventedPlayback", void 0);
        _define_property(this, "isFinished", void 0);
        _define_property(this, "restartSession", void 0);
        _define_property(this, "retrySession", void 0);
        _define_property(this, "play", void 0);
        _define_property(this, "pause", void 0);
        _define_property(this, "stop", void 0);
        _define_property(this, "seekToDate", void 0);
        _define_property(this, "seek", void 0);
        _define_property(this, "seekToLiveEdge", void 0);
        _define_property(this, "seekToLiveStart", void 0);
        _define_property(this, "isAtLiveEdge", void 0);
        _define_property(this, "isLinearScrubbingSupported", void 0);
        _define_property(this, "isSeekToDateSupported", void 0);
        _define_property(this, "setVolume", void 0);
        _define_property(this, "setMute", void 0);
        _define_property(this, "setPlayerBitrateLimits", void 0);
        _define_property(this, "resetPlayerBitrateLimits", void 0);
        _define_property(this, "enableSubtitles", void 0);
        _define_property(this, "disableSubtitles", void 0);
        _define_property(this, "setAudioTrack", void 0);
        _define_property(this, "setPin", void 0);
        _define_property(this, "setThumbnailVariant", void 0);
        _define_property(this, "getThumbnailForTime", void 0);
        _define_property(this, "cancelPin", void 0);
        _define_property(this, "setUserWaitStarted", void 0);
        _define_property(this, "setUserWaitEnded", void 0);
        _define_property(this, "getLiveWindow", void 0);
        _define_property(this, "updateAssetMetadata", void 0);
        _define_property(this, "waitForState", void 0);
        _define_property(this, "getMaxVideoFormat", void 0);
        _define_property(this, "getSupportedColourSpaces", void 0);
        _define_property(this, "getSupportedMaxHdcpLevel", void 0);
        _define_property(this, "getSupportedAudioFormats", void 0);
        _define_property(this, "getConnectedHdcpLevel", void 0);
        _define_property(this, "getWidevineSecurityLevel", void 0);
        _define_property(this, "getSupportedVideoCodecs", void 0);
        /** register an EventCue, for which we may also register an onCueEntered and onCueExited events.
     * startTime and endTime may be either a number indicating the stream position, or a Date representing
     * the absoluteDate position of the stream.
     */ _define_property(this, "registerCue", void 0);
        /** unregister an EventCue */ _define_property(this, "unregisterCue", void 0);
        /**
     * Register callback(s) for the onCueEntered event for a given type. So that
     * when a registered cue is entered, which has the same 'type', The onCueEntered callback(s) registered under that type will be invoked.
     */ _define_property(this, "onCueEntered", void 0);
        /**
     * Register callback(s) for the onCueExited event for a given type. So that
     * when a registered cue is exited which has the same 'type'. The onCueExited callback(s) registered under that type will be invoked.
     */ _define_property(this, "onCueExited", void 0);
        _define_property(this, "onCueRegistered", void 0);
        _define_property(this, "onCueUpdated", void 0);
        _define_property(this, "onCueUnregistered", void 0);
        // @ts-ignore
        _define_property(this, "error", void 0);
        _define_property(this, "currentState", void 0);
        _define_property(this, "csaiTransitionTimer", void 0);
        _define_property(this, "maxCsaiTransitionTimeSecs", 10);
        this.getCurrentSessionState = function() {
            return _this.currentState;
        };
        if ((_config_csai = config.csai) === null || _config_csai === void 0 ? void 0 : _config_csai.maxTransitionTimeSecs) {
            this.maxCsaiTransitionTimeSecs = config.csai.maxTransitionTimeSecs;
        }
        this.onError = sessionProxy.onError.bind(sessionProxy);
        this.onWarning = sessionProxy.onWarning.bind(sessionProxy);
        this.onAvailableAudioTracksChanged = sessionProxy.onAvailableAudioTracksChanged.bind(sessionProxy);
        this.onAvailableSubtitlesTracksChanged = sessionProxy.onAvailableSubtitlesTracksChanged.bind(sessionProxy);
        this.onAvailableThumbnailVariantsChanged = sessionProxy.onAvailableThumbnailVariantsChanged.bind(sessionProxy);
        this.onSeekStarted = sessionProxy.onSeekStarted.bind(sessionProxy);
        this.onSeekEnded = sessionProxy.onSeekEnded.bind(sessionProxy);
        this.onSubtitleCuesChanged = sessionProxy.onSubtitleCuesChanged.bind(sessionProxy);
        this.onVolumeChanged = sessionProxy.onVolumeChanged.bind(sessionProxy);
        this.onMuteChanged = sessionProxy.onMuteChanged.bind(sessionProxy);
        this.onSessionEnded = sessionProxy.onSessionEnded.bind(sessionProxy);
        this.onPlayoutDataReceived = sessionProxy.onPlayoutDataReceived.bind(sessionProxy);
        this.onPlayoutRulesReceived = sessionProxy.onPlayoutRulesReceived.bind(sessionProxy);
        this.onEventBoundary = sessionProxy.onEventBoundary.bind(sessionProxy);
        this.onEndOfEventMarkerReceived = sessionProxy.onEndOfEventMarkerReceived.bind(sessionProxy);
        this.onAdStarted = sessionProxy.onAdStarted.bind(sessionProxy);
        this.onAdFinished = sessionProxy.onAdFinished.bind(sessionProxy);
        this.onAdBreakDataReceived = sessionProxy.onAdBreakDataReceived.bind(sessionProxy);
        this.onAdPositionChanged = sessionProxy.onAdPositionChanged.bind(sessionProxy);
        this.onPauseAd = sessionProxy.onPauseAd.bind(sessionProxy);
        this.onVerifyCompanionAdInsertionEnabled = sessionProxy.onVerifyCompanionAdInsertionEnabled.bind(sessionProxy);
        this.onCompanionAdOpportunityStarted = sessionProxy.onCompanionAdOpportunityStarted.bind(sessionProxy);
        this.onCompanionAdOpportunityEnded = sessionProxy.onCompanionAdOpportunityEnded.bind(sessionProxy);
        this.onRenderWatermark = sessionProxy.onRenderWatermark.bind(sessionProxy);
        this.onClearWatermark = sessionProxy.onClearWatermark.bind(sessionProxy);
        this.onClearWatermarks = sessionProxy.onClearWatermarks.bind(sessionProxy);
        this.onPinRequired = sessionProxy.onPinRequired.bind(sessionProxy);
        this.onPinSuccess = sessionProxy.onPinSuccess.bind(sessionProxy);
        this.onAutoPlayPolicyPreventedPlayback = sessionProxy.onAutoPlayPolicyPreventedPlayback.bind(sessionProxy);
        this.onAdBreakStarted = sessionProxy.onAdBreakStarted.bind(sessionProxy);
        this.onAdBreakFinished = sessionProxy.onAdBreakFinished.bind(sessionProxy);
        this.onAudioTrackChanged = sessionProxy.onAudioTrackChanged.bind(sessionProxy);
        this.onSessionRetryStarted = sessionProxy.onSessionRetryStarted.bind(sessionProxy);
        this.onSessionRetryEnded = sessionProxy.onSessionRetryEnded.bind(sessionProxy);
        this.onSessionRestartStarted = sessionProxy.onSessionRestartStarted.bind(sessionProxy);
        this.onSessionRestartEnded = sessionProxy.onSessionRestartEnded.bind(sessionProxy);
        this.registerCue = sessionProxy.registerCue.bind(sessionProxy);
        this.unregisterCue = sessionProxy.unregisterCue.bind(sessionProxy);
        this.onCueEntered = sessionProxy.onEventCueEntered.bind(sessionProxy);
        this.onCueExited = sessionProxy.onEventCueExited.bind(sessionProxy);
        this.onCueRegistered = sessionProxy.onEventCueRegistered.bind(sessionProxy);
        this.onCueUnregistered = sessionProxy.onEventCueUnregistered.bind(sessionProxy);
        this.onCueUpdated = sessionProxy.onCueUpdated.bind(sessionProxy);
        this.onSubtitlesTrackChanged = function(cb) {
            sessionProxy.onSubtitlesTrackChanged(function(track) {
                if (!(track === null || track === void 0 ? void 0 : track.forced)) cb(track === null || track === void 0 ? void 0 : track.id);
            });
        };
        this.onPlaybackTimelineUpdated = function(cb) {
            sessionProxy.onPlaybackTimelineUpdated(function(internalPlaybackTimeline) {
                // Prevent reporting position updates to clients but notify internal
                // session so that beacons are fired. Example: https://gspcloud.atlassian.net/browse/VPTJS-12164
                if (internalPlaybackTimeline.suppressTimelineUpdatesForClients) {
                    return;
                }
                var liveWindow = internalPlaybackTimeline.liveWindow, currentTime = internalPlaybackTimeline.currentTime, playbackTimeLine = _object_without_properties(internalPlaybackTimeline, [
                    "liveWindow",
                    "currentTime"
                ]);
                cb(playbackTimeLine);
            });
        };
        this.getLiveWindow = /*#__PURE__*/ _async_to_generator(function() {
            var internalLiveWindow;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            sessionProxy.getLiveWindow()
                        ];
                    case 1:
                        internalLiveWindow = _state.sent();
                        if (!internalLiveWindow) {
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            {
                                start: internalLiveWindow === null || internalLiveWindow === void 0 ? void 0 : internalLiveWindow.start,
                                startDate: internalLiveWindow === null || internalLiveWindow === void 0 ? void 0 : internalLiveWindow.startDate,
                                end: internalLiveWindow === null || internalLiveWindow === void 0 ? void 0 : internalLiveWindow.end
                            }
                        ];
                }
            });
        });
        this.onBitrateChanged = sessionProxy.onBitrateChanged.bind(sessionProxy);
        this.onEncodedFrameRateChanged = sessionProxy.onEncodedFrameRateChanged.bind(sessionProxy);
        this.onRenderedFrameRateChanged = sessionProxy.onRenderedFrameRateChanged.bind(sessionProxy);
        this.onVideoTrackChanged = sessionProxy.onVideoTrackChanged.bind(sessionProxy);
        this.onItuQaSessionData = sessionProxy.onItuQaSessionData.bind(sessionProxy);
        this.onStateChanged = function(callback) {
            sessionProxy.onStateChanged(function(state) {
                _this.handleInternalStateChanged(state, callback);
            });
        };
        var bindWithLogging = function(fnName) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _sdkLogger, _sessionProxy;
                (_sdkLogger = sdkLogger).verbose.apply(_sdkLogger, [
                    "Called SessionController.".concat(fnName, ":")
                ].concat(_to_consumable_array(args.map(JsonUtils.stringify))));
                // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- This is just a passthrough, so the type of method isn't important
                return (_sessionProxy = sessionProxy)[fnName].apply(_sessionProxy, _to_consumable_array(args));
            };
        };
        this.isFinished = bindWithLogging('isFinished');
        this.restartSession = bindWithLogging('restartSession');
        this.retrySession = bindWithLogging('retrySession');
        this.play = bindWithLogging('play');
        this.pause = bindWithLogging('pause');
        this.stop = bindWithLogging('stop');
        this.seek = bindWithLogging('seek');
        this.seekToDate = bindWithLogging('seekToDate');
        this.seekToLiveEdge = bindWithLogging('seekToLiveEdge');
        this.seekToLiveStart = bindWithLogging('seekToLiveStart');
        this.isAtLiveEdge = bindWithLogging('isAtLiveEdge');
        this.setVolume = bindWithLogging('setVolume');
        this.setMute = bindWithLogging('setMute');
        this.setPlayerBitrateLimits = bindWithLogging('setPlayerBitrateLimits');
        this.resetPlayerBitrateLimits = bindWithLogging('resetPlayerBitrateLimits');
        this.enableSubtitles = bindWithLogging('enableSubtitles');
        this.disableSubtitles = bindWithLogging('disableSubtitles');
        this.setAudioTrack = bindWithLogging('setAudioTrack');
        this.setPin = bindWithLogging('setPin');
        this.cancelPin = bindWithLogging('cancelPin');
        this.setUserWaitStarted = bindWithLogging('setUserWaitStarted');
        this.setUserWaitEnded = bindWithLogging('setUserWaitEnded');
        this.setThumbnailVariant = bindWithLogging('setThumbnailVariant');
        this.getThumbnailForTime = bindWithLogging('getThumbnailForTime');
        this.updateAssetMetadata = bindWithLogging('notifyAssetMetadataUpdated');
        this.getMaxVideoFormat = bindWithLogging('getMaxVideoFormat');
        this.getSupportedColourSpaces = bindWithLogging('getSupportedColourSpaces');
        this.getSupportedAudioFormats = bindWithLogging('getSupportedAudioFormats');
        this.getSupportedMaxHdcpLevel = bindWithLogging('getSupportedMaxHdcpLevel');
        this.getConnectedHdcpLevel = bindWithLogging('getConnectedHdcpLevel');
        this.getWidevineSecurityLevel = bindWithLogging('getWidevineSecurityLevel');
        this.getSupportedVideoCodecs = bindWithLogging('getSupportedVideoCodecs');
        this.error = bindWithLogging('notifyError');
        this.isSeekToDateSupported = sessionProxy.isSeekToDateSupported.bind(sessionProxy);
        this.isLinearScrubbingSupported = sessionProxy.isLinearScrubbingSupported.bind(sessionProxy);
        this.waitForState = function(state) {
            return sessionProxy.waitForState(ReverseMappedSessionStateForClients[state]);
        };
    }
    _create_class(SessionController, [
        {
            key: "clearCsaiTransitionTimer",
            value: function clearCsaiTransitionTimer() {
                if (this.csaiTransitionTimer) {
                    clearTimeout(this.csaiTransitionTimer);
                }
            }
        },
        {
            key: "startCsaiTransitionTimer",
            value: function startCsaiTransitionTimer(notifySessionStateChanged) {
                var _this = this;
                this.csaiTransitionTimer = setTimeout(function() {
                    notifySessionStateChanged(SessionState.Rebuffering);
                    _this.currentState = SessionState.Rebuffering;
                }, this.maxCsaiTransitionTimeSecs * 1000);
            }
        },
        {
            key: "handleInternalStateChanged",
            value: function handleInternalStateChanged(state, notifySessionStateChanged) {
                this.clearCsaiTransitionTimer();
                if (state === InternalSessionState.CsaiTransition) this.startCsaiTransitionTimer(notifySessionStateChanged);
                notifySessionStateChanged(MappedSessionStateForClients[state]);
                this.currentState = MappedSessionStateForClients[state];
            }
        }
    ]);
    return SessionController;
}();

//# sourceMappingURL=session-controller.js.map